define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class offerService
     */
    function OfferService() {
        var self = this;

        // Offers Object
        // startDate: Starting date of the current offer with format YYYY-MM-DD
        // markets : markets id to consider for the current offer
        // TODO: migrate to a full db table with offers
        var OFFERS = {
            TRAD: {
                startDate: '2018-02-06',
                markets: ['TABACPRESSE', 'BOULANGERIE', 'AUTRE', 'FLEURISTE']
            },
            NAP: {
                startDate: '2017-10-05',
                markets: ['TABACPRESSE']
            },
            FLORAJET: {
                startDate: '2018-08-01',
                markets: ['FLEURISTE']
            }
        };

        // Date du passage à la nouvelle gestion du scanup sur NAP
        var SCANUP_NO_MORE_INCLUDED_WITH_NAP = new Date('2020-01-16');

        /**
         * Get a property for the OFFERS object of this service
         * @param  {object} orderType
         * @param  {String} prop      OFFERS property wanted
         * @return {String} given property
         */
        self.getOfferProperty = function getOfferProperty(orderType, prop) {
            return OFFERS[orderType.code][prop];
        };

        /**
         * Check if a given order is an older offer. Only apply for signed orders and compare offerDate > dateCreated
         * @param  {Object}  order
         * @return {Boolean}
         */
        self.isOlderOffer = function isOlderOffer(order) {
            var offerDate = OFFERS[order.orderType.code].startDate;
            var isMarketInOffer = OFFERS[order.orderType.code].markets.indexOf(order.marketType.code) > -1;
            if (!offerDate || isMarketInOffer === false) {
                return false;
            }
            var isOrderCreatedInNewOffer = moment(offerDate).isAfter(order.dateCreated);
            if (order.orderType.code === 'NAP') {
                return order.isSigned && isOrderCreatedInNewOffer;
            }
            else {
                return isOrderCreatedInNewOffer;
            }
        };

        /**
         * Check if a given order is an offer with scan'up included
         * @param  {Object}  order
         * @return {Boolean}
         */
        self.offerWithScanupIncluded = function offerWithScanupIncluded(order) {
            if (order.orderType.code !== 'NAP') {
                return false;
            }
            if (order.orderType.code === 'PERIPHERIQUE') {
                return false;
            }

            // If it is a new order
            if (typeof order.dateCreated === 'undefined') {
                return false;
            }

            // If the order was created after the new rule
            let createdDate = new Date(order.dateCreated);
            if (createdDate.getTime() > SCANUP_NO_MORE_INCLUDED_WITH_NAP.getTime()) {
                return false;
            }

            return true;
        };

        return self;
    }

    OfferService.$inject = [];

    angular.module('app.bdc.common.offerService', []).factory('offerService', OfferService);
});
